export default class Versicherung {
    public versicherung_id: number | null = null;
    public versicherung: string | null = null;
    public bezeichnung: string | null = null;
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Versicherung>) {
        Object.assign(this, data);
    }
}
